<a   class="round-button"><i class="fa fa-play fa-2x"></i></a>
